import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PostsManager } from "./admin/PostsManager";
import { ClassesManager } from "./admin/ClassesManager";
import { StatsManager } from "./admin/StatsManager";
import { EmailProviderSwitch } from "./admin/EmailProviderSwitch";
import { BarChart3, BookOpen, Dumbbell, Settings } from "lucide-react";
import { useProfile } from "@/hooks/useProfile";

interface AdminTabProps {
  defaultSubtab?: string;
}

export const AdminTab = ({ defaultSubtab }: AdminTabProps) => {
  const { profile } = useProfile();
  const isAdmin = profile?.role === 'admin';

  return (
    <div className="space-y-4">
      <div className="bg-card backdrop-blur-lg rounded-xl p-6 border border-border">
        <Tabs defaultValue={defaultSubtab || "posts"} className="w-full">
          <TabsList className={`grid w-full ${isAdmin ? 'grid-cols-4' : 'grid-cols-3'}`}>
            <TabsTrigger value="posts" className="flex items-center gap-2">
              <BookOpen className="h-4 w-4" />
              Posts
            </TabsTrigger>
            <TabsTrigger value="classes" className="flex items-center gap-2">
              <Dumbbell className="h-4 w-4" />
              Clases
            </TabsTrigger>
            <TabsTrigger value="stats" className="flex items-center gap-2">
              <BarChart3 className="h-4 w-4" />
              Estadísticas
            </TabsTrigger>
            {isAdmin && (
              <TabsTrigger value="sistema" className="flex items-center gap-2">
                <Settings className="h-4 w-4" />
                Sistema
              </TabsTrigger>
            )}
          </TabsList>

          <TabsContent value="posts" className="mt-4">
            <PostsManager />
          </TabsContent>

          <TabsContent value="classes" className="mt-4">
            <ClassesManager />
          </TabsContent>

          <TabsContent value="stats" className="mt-4">
            <StatsManager />
          </TabsContent>

          {isAdmin && (
            <TabsContent value="sistema" className="mt-4 space-y-4">
              <h3 className="text-lg font-semibold">Configuración del Sistema</h3>
              <EmailProviderSwitch />
            </TabsContent>
          )}
        </Tabs>
      </div>
    </div>
  );
};